<template>
  <div
    class="offer-update tw-flex tw-sticky tw-top-64px tw-z-1"
    v-if="isUpdated"
  >
    <div class="tw-bg-yellow-500">
      <ui-ctk-icon
        class="tw-text-5xl tw-block tw-text-white"
        name="warning"
        data-test="icon"
      />
    </div>
    <div class="tw-relative tw-flex tw-items-center tw-bg-yellow-400 tw-px-4 tw-py-2 tw-w-full">
      <div
        v-text="$t('offer.updated')"
        class="tw-text-yellow-700"
        data-test="expiration"
      />
    </div>
  </div>
</template>

<script>
  import { defineComponent } from '@vue/composition-api'

  /**
   * @module component - OfferUpdate
   */
  export default defineComponent({
    props: {
      isUpdated: {
        required: true,
        default: false,
        type: Boolean
      }
    }
  })
</script>

<style lang="scss" scoped>
  .offer-update {
    min-height: 64px;
  }
</style>
